import { LiveStatus } from '@/gql/graphql';
import type { TFunction } from 'i18next';

const STATUS_COLORS: Record<string, string> = {
    [LiveStatus.Dnf]: 'text-red-500',
    [LiveStatus.Dns]: 'text-slate-400',
    [LiveStatus.NotStarted]: 'text-slate-300',
    [LiveStatus.Running]: 'text-slate-400',
};

export function getLiveStatusLabel(status: LiveStatus | null | undefined, t: TFunction): string {
    if (status === LiveStatus.Dnf) return t('details.liveTracking.dnf');
    if (status === LiveStatus.Dns) return t('details.liveTracking.dns');
    if (status === LiveStatus.NotStarted) return t('details.liveTracking.notStartedStatus');
    return t('details.liveTracking.inProgress');
}

export function getLiveStatusColor(status: LiveStatus | null | undefined): string {
    if (!status) return 'text-slate-400';
    return STATUS_COLORS[status] ?? 'text-slate-400';
}
